import { Form, Table, Footer } from './Components'
import Title from '../../components/Title/index'
import styles from './styles.module.scss'
import { useNavigate } from 'react-router-dom'
import Button from '../../components/Button'
import { RiFileExcel2Fill } from 'react-icons/ri'

const SchedulingVD = () => {
  const navigate = useNavigate()

  const goHome = () => navigate('/')

  return (
    <div className={styles.wrapper}>
      <Title title="Составление расписания ВД" />
      <Form />

      <div className={styles.contentArea}>
        <div className={styles.tableArea}>
          <Table />
        </div>

        <div className={styles.sidebar}>
          <Button className={styles.sidebarBtn} mode='white'>
            <RiFileExcel2Fill size={15} color='#217346' />
            Экспорт в Excel
          </Button>
          <Button className={styles.sidebarBtn} mode='white'>Проверить ошибки</Button>
        </div>
      </div>

      <Footer goHome={goHome} />
    </div>
  )
}

export default SchedulingVD
